module.exports = __webpack_public_path__ + "img/samplebottles_1_150ppi.da86c520.png";